module.exports = __webpack_public_path__ + "img/1487513440.0c2fbba9.jpg";